import * as React from 'react'
import SelectSearch from 'react-select-search';
import ItemMoney from '../itemMoney'
class ListMoney extends React.Component {
    render(props) {
        let { prefer, options ,moneys ,getValue,handleAddPrefer} = this.props;
        let count = prefer.length;
        const renderItemMoney = prefer.map((item, index) => {
            let {donate, program} = prefer
            return (
                <ItemMoney
                    count={count}
                    index={index}
                    key={`list-option-${index}`}
                    active={index == 0 ? 'active' : ''}
                    options={options}
                    data={moneys}
                    handleAddPrefer={handleAddPrefer}
                    getValue={getValue}
                />
            )
        })
        return (
            <>{renderItemMoney}</>
        )
    }
}

export default ListMoney;